"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ApiGetInstitutionObjectParticipantsInnerAvatar = _interopRequireDefault(require("./ApiGetInstitutionObjectParticipantsInnerAvatar"));
var _ApiGetInstitutionObjectParticipantsInnerQuestionnairesInner = _interopRequireDefault(require("./ApiGetInstitutionObjectParticipantsInnerQuestionnairesInner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The ApiGetInstitutionObjectParticipantsInner model module.
 * @module model/ApiGetInstitutionObjectParticipantsInner
 * @version 4.0.0
 */
var ApiGetInstitutionObjectParticipantsInner = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ApiGetInstitutionObjectParticipantsInner</code>.
   * @alias module:model/ApiGetInstitutionObjectParticipantsInner
   */
  function ApiGetInstitutionObjectParticipantsInner() {
    _classCallCheck(this, ApiGetInstitutionObjectParticipantsInner);
    ApiGetInstitutionObjectParticipantsInner.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(ApiGetInstitutionObjectParticipantsInner, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>ApiGetInstitutionObjectParticipantsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ApiGetInstitutionObjectParticipantsInner} obj Optional instance to populate.
     * @return {module:model/ApiGetInstitutionObjectParticipantsInner} The populated <code>ApiGetInstitutionObjectParticipantsInner</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ApiGetInstitutionObjectParticipantsInner();
        if (data.hasOwnProperty('uid')) {
          obj['uid'] = _ApiClient["default"].convertToType(data['uid'], 'Number');
        }
        if (data.hasOwnProperty('study_id')) {
          obj['study_id'] = _ApiClient["default"].convertToType(data['study_id'], 'String');
        }
        if (data.hasOwnProperty('joined_time_in_seconds')) {
          obj['joined_time_in_seconds'] = _ApiClient["default"].convertToType(data['joined_time_in_seconds'], 'Number');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('institution_nid')) {
          obj['institution_nid'] = _ApiClient["default"].convertToType(data['institution_nid'], 'Number');
        }
        if (data.hasOwnProperty('number_of_records')) {
          obj['number_of_records'] = _ApiClient["default"].convertToType(data['number_of_records'], 'Number');
        }
        if (data.hasOwnProperty('first_record')) {
          obj['first_record'] = _ApiClient["default"].convertToType(data['first_record'], 'Number');
        }
        if (data.hasOwnProperty('last_record')) {
          obj['last_record'] = _ApiClient["default"].convertToType(data['last_record'], 'Number');
        }
        if (data.hasOwnProperty('last_record_timing')) {
          obj['last_record_timing'] = _ApiClient["default"].convertToType(data['last_record_timing'], 'String');
        }
        if (data.hasOwnProperty('first_record_timing')) {
          obj['first_record_timing'] = _ApiClient["default"].convertToType(data['first_record_timing'], 'String');
        }
        if (data.hasOwnProperty('number_of_pain_records')) {
          obj['number_of_pain_records'] = _ApiClient["default"].convertToType(data['number_of_pain_records'], 'Number');
        }
        if (data.hasOwnProperty('number_of_daily_reflections')) {
          obj['number_of_daily_reflections'] = _ApiClient["default"].convertToType(data['number_of_daily_reflections'], 'Number');
        }
        if (data.hasOwnProperty('email_verified')) {
          obj['email_verified'] = _ApiClient["default"].convertToType(data['email_verified'], 'Boolean');
        }
        if (data.hasOwnProperty('email')) {
          obj['email'] = _ApiClient["default"].convertToType(data['email'], 'String');
        }
        if (data.hasOwnProperty('connected_to_facebook')) {
          obj['connected_to_facebook'] = _ApiClient["default"].convertToType(data['connected_to_facebook'], 'Boolean');
        }
        if (data.hasOwnProperty('connected_to_google')) {
          obj['connected_to_google'] = _ApiClient["default"].convertToType(data['connected_to_google'], 'Boolean');
        }
        if (data.hasOwnProperty('connected_to_apple')) {
          obj['connected_to_apple'] = _ApiClient["default"].convertToType(data['connected_to_apple'], 'Boolean');
        }
        if (data.hasOwnProperty('avatar')) {
          obj['avatar'] = _ApiGetInstitutionObjectParticipantsInnerAvatar["default"].constructFromObject(data['avatar']);
        }
        if (data.hasOwnProperty('questionnaires')) {
          obj['questionnaires'] = _ApiClient["default"].convertToType(data['questionnaires'], [_ApiGetInstitutionObjectParticipantsInnerQuestionnairesInner["default"]]);
        }
        if (data.hasOwnProperty('utm_campaign')) {
          obj['utm_campaign'] = _ApiClient["default"].convertToType(data['utm_campaign'], 'String');
        }
        if (data.hasOwnProperty('utm_medium')) {
          obj['utm_medium'] = _ApiClient["default"].convertToType(data['utm_medium'], 'String');
        }
        if (data.hasOwnProperty('utm_source')) {
          obj['utm_source'] = _ApiClient["default"].convertToType(data['utm_source'], 'String');
        }
        if (data.hasOwnProperty('registration_code')) {
          obj['registration_code'] = _ApiClient["default"].convertToType(data['registration_code'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ApiGetInstitutionObjectParticipantsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ApiGetInstitutionObjectParticipantsInner</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['study_id'] && !(typeof data['study_id'] === 'string' || data['study_id'] instanceof String)) {
        throw new Error("Expected the field `study_id` to be a primitive type in the JSON string but got " + data['study_id']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['last_record_timing'] && !(typeof data['last_record_timing'] === 'string' || data['last_record_timing'] instanceof String)) {
        throw new Error("Expected the field `last_record_timing` to be a primitive type in the JSON string but got " + data['last_record_timing']);
      }
      // ensure the json data is a string
      if (data['first_record_timing'] && !(typeof data['first_record_timing'] === 'string' || data['first_record_timing'] instanceof String)) {
        throw new Error("Expected the field `first_record_timing` to be a primitive type in the JSON string but got " + data['first_record_timing']);
      }
      // ensure the json data is a string
      if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
        throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
      }
      // validate the optional field `avatar`
      if (data['avatar']) {
        // data not null
        _ApiGetInstitutionObjectParticipantsInnerAvatar["default"].validateJSON(data['avatar']);
      }
      if (data['questionnaires']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['questionnaires'])) {
          throw new Error("Expected the field `questionnaires` to be an array in the JSON data but got " + data['questionnaires']);
        }
        // validate the optional field `questionnaires` (array)
        var _iterator = _createForOfIteratorHelper(data['questionnaires']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _ApiGetInstitutionObjectParticipantsInnerQuestionnairesInner["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      // ensure the json data is a string
      if (data['utm_campaign'] && !(typeof data['utm_campaign'] === 'string' || data['utm_campaign'] instanceof String)) {
        throw new Error("Expected the field `utm_campaign` to be a primitive type in the JSON string but got " + data['utm_campaign']);
      }
      // ensure the json data is a string
      if (data['utm_medium'] && !(typeof data['utm_medium'] === 'string' || data['utm_medium'] instanceof String)) {
        throw new Error("Expected the field `utm_medium` to be a primitive type in the JSON string but got " + data['utm_medium']);
      }
      // ensure the json data is a string
      if (data['utm_source'] && !(typeof data['utm_source'] === 'string' || data['utm_source'] instanceof String)) {
        throw new Error("Expected the field `utm_source` to be a primitive type in the JSON string but got " + data['utm_source']);
      }
      // ensure the json data is a string
      if (data['registration_code'] && !(typeof data['registration_code'] === 'string' || data['registration_code'] instanceof String)) {
        throw new Error("Expected the field `registration_code` to be a primitive type in the JSON string but got " + data['registration_code']);
      }
      return true;
    }
  }]);
}();
/**
 * User ID
 * @member {Number} uid
 */
ApiGetInstitutionObjectParticipantsInner.prototype['uid'] = undefined;

/**
 * Participant ID in institution. If child institutions included and user has multiple assignments, it will be Study ID of the earliest joined Institution where participant has `active` status.
 * @member {String} study_id
 */
ApiGetInstitutionObjectParticipantsInner.prototype['study_id'] = undefined;

/**
 * Time in seconds when user joined his account (in timestamp format, from 1st Jan 1970). If child institutions included and user has multiple assignments, it will be the earliest joined Institution where participant has `active` status.
 * @member {Number} joined_time_in_seconds
 */
ApiGetInstitutionObjectParticipantsInner.prototype['joined_time_in_seconds'] = undefined;

/**
 * Participant status. If child institutions included and user has multiple assignments and one of assignment has `active` status - it will be `active`.
 * @member {module:model/ApiGetInstitutionObjectParticipantsInner.StatusEnum} status
 */
ApiGetInstitutionObjectParticipantsInner.prototype['status'] = undefined;

/**
 * Institution ID which participant assigned to. If child institutions included and user has multiple assignments, it will be Institution ID of earliest joined Institution where participant has `active` status.
 * @member {Number} institution_nid
 */
ApiGetInstitutionObjectParticipantsInner.prototype['institution_nid'] = undefined;

/**
 * Number of all pain records, this number should satisfy the following formula `number_of_records = number_of_daily_reflections + number_of_pain_records`
 * @member {Number} number_of_records
 */
ApiGetInstitutionObjectParticipantsInner.prototype['number_of_records'] = undefined;

/**
 * Time in seconds of the first added record (in timestamp format, from 1st Jan 1970)
 * @member {Number} first_record
 */
ApiGetInstitutionObjectParticipantsInner.prototype['first_record'] = undefined;

/**
 * Time in seconds of the last added record (in timestamp format, from 1st Jan 1970)
 * @member {Number} last_record
 */
ApiGetInstitutionObjectParticipantsInner.prototype['last_record'] = undefined;

/**
 * Y-m-d representation of timing + time_offset for the latest record for the user
 * @member {String} last_record_timing
 */
ApiGetInstitutionObjectParticipantsInner.prototype['last_record_timing'] = undefined;

/**
 * Y-m-d representation of timing + time_offset for the first record for the user
 * @member {String} first_record_timing
 */
ApiGetInstitutionObjectParticipantsInner.prototype['first_record_timing'] = undefined;

/**
 * Number of the pain records of type 'pain record'
 * @member {Number} number_of_pain_records
 */
ApiGetInstitutionObjectParticipantsInner.prototype['number_of_pain_records'] = undefined;

/**
 * Number of the pain records of type 'daily reflection'
 * @member {Number} number_of_daily_reflections
 */
ApiGetInstitutionObjectParticipantsInner.prototype['number_of_daily_reflections'] = undefined;

/**
 * Indicates whether user activated their account or not
 * @member {Boolean} email_verified
 */
ApiGetInstitutionObjectParticipantsInner.prototype['email_verified'] = undefined;

/**
 * Account email. Will be returned if \"Hide user info\" disabled.
 * @member {String} email
 */
ApiGetInstitutionObjectParticipantsInner.prototype['email'] = undefined;

/**
 * Indicates whether user connected Facebook account or not. Will be returned if \"Hide user info\" disabled.
 * @member {Boolean} connected_to_facebook
 */
ApiGetInstitutionObjectParticipantsInner.prototype['connected_to_facebook'] = undefined;

/**
 * Indicates whether user connected Google account or not. Will be returned if \"Hide user info\" disabled.
 * @member {Boolean} connected_to_google
 */
ApiGetInstitutionObjectParticipantsInner.prototype['connected_to_google'] = undefined;

/**
 * Indicates whether user connected Apple account or not. Will be returned if \"Hide user info\" disabled.
 * @member {Boolean} connected_to_apple
 */
ApiGetInstitutionObjectParticipantsInner.prototype['connected_to_apple'] = undefined;

/**
 * @member {module:model/ApiGetInstitutionObjectParticipantsInnerAvatar} avatar
 */
ApiGetInstitutionObjectParticipantsInner.prototype['avatar'] = undefined;

/**
 * @member {Array.<module:model/ApiGetInstitutionObjectParticipantsInnerQuestionnairesInner>} questionnaires
 */
ApiGetInstitutionObjectParticipantsInner.prototype['questionnaires'] = undefined;

/**
 * @member {String} utm_campaign
 */
ApiGetInstitutionObjectParticipantsInner.prototype['utm_campaign'] = undefined;

/**
 * @member {String} utm_medium
 */
ApiGetInstitutionObjectParticipantsInner.prototype['utm_medium'] = undefined;

/**
 * @member {String} utm_source
 */
ApiGetInstitutionObjectParticipantsInner.prototype['utm_source'] = undefined;

/**
 * Registration code value that was used by the participant when they joined to the institution
 * @member {String} registration_code
 */
ApiGetInstitutionObjectParticipantsInner.prototype['registration_code'] = undefined;

/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
ApiGetInstitutionObjectParticipantsInner['StatusEnum'] = {
  /**
   * value: "active"
   * @const
   */
  "active": "active",
  /**
   * value: "inactive"
   * @const
   */
  "inactive": "inactive"
};
var _default = exports["default"] = ApiGetInstitutionObjectParticipantsInner;